import React from 'react';
import SearchBarFilters from './SearchBarFilters';

function SearchBar() {
  return (
    <SearchBarFilters />
  );
}

export default SearchBar;
